<template lang="pug"> 
  transition(name="fade")
    #intro(@click="onClick") 
</template>

<script>


import { mapState, mapMutations } from 'vuex' 
import TweenMax from 'gsap'

export default {

  name: 'intro',
  
  components: {},
  
  data() {
    return {}
  },
  
  computed: {
    ...mapState('app', ['loading'])
  },
  
  mounted() { 
  },
  
  beforeDestroy() {},
  
  methods: {
    onClick() {
      //this.$router.replace({ name: 'question' });
    }
  },
  
  watch: { 
    'loading.completed'(val){}
  }

}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#intro
  +full()
  +flex-center() 

</style>







